<template>
  <header class="lg:absolute top-0 w-full">
    <div class="container-main w-full">
      <div class="flex w-full justify-between lg:py-[30px] md:py-[12px] pt-[10px] items-center">
        <div class="flex">
          <router-link :to="{ name: '/home' }" class="mx-auto lg:ml-auto xl:mr-0 xl:mx-0 xl:shrink-0" @click="$emit('close-mobile-menu')">
            <figure>
              <img loading="lazy" src="/img/logo/logo-kids-mobile.svg" alt="logo-mobile" class="min-[350px]:w-[260px] w-[136px]" />
            </figure>
          </router-link>
        </div>
        <div class="flex items-center gap-2 xl:gap-6 ml-[auto]">
          <!-- B6 MVP: hide cart icon. Restore with HeaderCart when cart returns.
          <HeaderCart />
          -->

          <HeaderProfileList />
          <div>
            <LocalesSwitcher list-position="left" />
          </div>
        </div>
      </div>
    </div>
  </header>
  <main>
    <slot></slot>
  </main>
</template>

<script setup lang="ts">
import LocalesSwitcher from "@/components/LocalesSwitcher.vue"
import HeaderProfileList from "@/components/header/header-nav/HeaderProfilesList.vue"
// B6 MVP: restore HeaderCart import with the icon.
// import HeaderCart from "@/components/header/header-nav/HeaderCart.vue"
</script>
